<template>
  <form @submit.prevent="clickEvent">
    <div class="row g-2 align-items-end">
      <div class="col-md-4">
        <label for="transfer-batch-no">Batch No.</label>
        <input
          v-model="inputTransferNo"
          type="text"
          class="form-control"
          style="width: 100%"
          id="transfer-batch-no"
        />
      </div>
      <div class="col-md-4">
        <label for="batch-status">Batch Status</label>
        <select
          v-model="inputBatchStatus"
          id="batch-status"
          class="form-select"
          style="width: 100%"
        >
          <option selected value="">Select...</option>
          <option>Received</option>
          <option>Accepted</option>
          <option>Failed</option>
          <option>Identified</option>
        </select>
      </div>
      <div class="col-md-4">
        <label for="batch-status-date">Batch Status Date</label>
        <input
          v-model="inputBatchStatusDate"
          type="date"
          class="form-control"
          style="width: 100%"
          id="batch-status-date"
        />
      </div>
    </div>
    <div class="row g-2 align-items-end">
      <!-- <div class="col-md-4">
        <label for="transferring-agency">Transferring Agency</label>
        <select
          v-model="inputTransferAgency"
          id="transferring-agency"
          class="form-select"
          style="width: 100%"
        >
          <option selected value="">Select...</option>
          <option v-for="data in AgencyList" :value="data['AgencyName']">
            {{ data["AgencyDisplayName"] }}
          </option>
        </select>
      </div> -->
      <div class="col-md-4">
        <label for="content-type">Content Type</label>
        <select
          v-model="inputContentType"
          id="content-type"
          class="form-select"
          style="width: 100%"
        >
          <option selected value="">Select...</option>
          <option value="System Configuration Updates">System Configuration Updates</option>
          <option value="Transfer">Transfer</option>
          <option value="Reingest Request">Reingest Request</option>
          <option value="Dissemination Request">Dissemination Request</option>
          <option value="Package Status Updates">Package Status Updates</option>
          <option value="Workflow Definition">Workflow Definition</option>
          <option value="File Format Category Changes">
            File Format Category Changes
          </option>
          <option value="Unknown">Unknown</option>
        </select>
      </div>
      <div class="col-md-4">
        <button
          @click="clearAll"
          type="button"
          class="btn btn-clear btn-outline-secondary"
          style="width: 100%"
        >
          Clear All / Refresh
        </button>
      </div>
      <div class="col-md-4">
        <button
          @click="clickEvent"
          type="button"
          class="btn btn-search btn-primary"
          style="width: 100%"
        >
          Search
        </button>
      </div>
    </div>
  </form>
</template>

<script setup lang="ts">
import AgencyList from "../../../public/AgencyList.json";
import { useContentStore } from "@/stores/content_review/content";
import moment from "moment";
import { ref } from "vue";

const contentStore = useContentStore();

const inputTransferNo: any = ref(contentStore.currentFilters[0].filterText);
const inputTransferAgency: any = ref(contentStore.currentFilters[1].filterText);
const inputBatchStatus: any = ref(contentStore.currentFilters[2].filterText);
const inputContentType = ref(contentStore.currentFilters[3].filterText);
const inputBatchStatusDate: any = ref(
  contentStore.currentFilters[4].filterText
);
const convertedStatusDate = ref("");
const dayRange = 86399;

const emit = defineEmits(["listenTransferNumber"]);

const clickEvent = () => {
  if (inputBatchStatusDate.value)
    convertedStatusDate.value = `${moment(inputBatchStatusDate.value).unix()}-${
      moment(inputBatchStatusDate.value).unix() + dayRange
    }`;
  let searchField = {
    transferNo: inputTransferNo.value,
    transferAgency: inputTransferAgency.value,
    batchStatus: inputBatchStatus.value,
    contentType: inputContentType.value,
    batchStatusDate: convertedStatusDate.value,
  };
  emit("listenTransferNumber", searchField);
};

const clearAll = () => {
  inputTransferNo.value = "";
  inputTransferAgency.value = "";
  inputBatchStatus.value = "";
  inputContentType.value = "";
  inputBatchStatusDate.value = "";
  convertedStatusDate.value = "";
  let searchField = {
    transferNo: inputTransferNo.value,
    transferAgency: inputTransferAgency.value,
    batchStatus: inputBatchStatus.value,
    contentType: inputContentType.value,
    batchStatusDate: convertedStatusDate.value,
  };
  emit("listenTransferNumber", searchField);
};
</script>
